import React from 'react';
import { useParams } from 'react-router';
import { useMutation, useQuery } from '@apollo/client';
import moment from 'moment';
import {
  SUBMIT_WITHDRAWAL,
  SUBMIT_WITHDRAWAL_WITH_CUSTOM_DATE,
  GET_WITHDRAWAL,
} from '../../../../../gql/withdrawals';
import WithdrawalDetail from './WithdrawalDetail';
import SubmitForm from './SubmitForm';
import {
  useHasScopeTypeInProject,
  useProjectFrozen,
} from '../../../../../hooks';
import { PageContainer } from '@ant-design/pro-layout';

const SubmitWithdrawal = ({ reducer: { dispatch } }) => {
  const { id, projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const { hasScopeType, loading: scopeLoading } = useHasScopeTypeInProject(
    'WRITE_WITHDRAWAL_WITH_CUSTOM_DATE'
  );
  const { data, loading } = useQuery(GET_WITHDRAWAL, {
    variables: {
      ids: [id],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });
  const [submitWithdrawal] = useMutation(
    hasScopeType ? SUBMIT_WITHDRAWAL_WITH_CUSTOM_DATE : SUBMIT_WITHDRAWAL,
    {
      refetchQueries: [
        {
          query: GET_WITHDRAWAL,
          variables: {
            ids: [id],
            status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
          },
        },
      ],
      awaitRefetchQueries: true,
      onCompleted: ({ submitWithdrawal: { status } }) => {
        switch (status) {
          case 'PENDING':
            dispatch({ type: 'APPROVAL' });
            break;
          case 'APPROVED':
            dispatch({ type: 'RESULT' });
            break;
          default:
            dispatch({ type: 'APPROVAL' });
            break;
        }
      },
    }
  );

  return (
    <PageContainer loading={loading}>
      <WithdrawalDetail
        data={data}
        title="Confirm Withdrawal Detail"
        confirm={true}
      />
      <SubmitForm
        projectFrozen={projectFrozen}
        withCustomDate={hasScopeType}
        loading={scopeLoading}
        onFinish={async ({ date }) => {
          const input = {
            id,
            projectId,
          };
          if (hasScopeType) {
            input.date = moment(date).format('YYYY-MM-DD');
          }
          await submitWithdrawal({
            variables: {
              input,
            },
          });
        }}
        onReset={() => {
          dispatch({ type: 'APPLY' });
        }}
      />
    </PageContainer>
  );
};

export default SubmitWithdrawal;
